import { Link } from "react-router-dom";

export function NotificationBell({ unreadCount }: { unreadCount: number }) {
  return (
    <div className="relative">
      <Link
        aria-label="Notifications"
        className="relative inline-flex items-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        to="/notifications"
      >
        <svg aria-hidden="true" className="h-6 w-6" fill="none" viewBox="0 0 24 24">
          <path
            d="M15 17H9m9-1V11a6 6 0 10-12 0v5l-2 2h16l-2-2zm-7 2a1 1 0 002 0"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.8"
          />
        </svg>
        {unreadCount > 0 ? (
          <span className="absolute right-1 top-1 inline-flex h-4 w-4 items-center justify-center rounded-full bg-red-600 outline outline-2 outline-white text-[10px] font-bold text-white">
            {unreadCount}
          </span>
        ) : null}
      </Link>
    </div>
  );
}
